import { memo } from "react";
import { Popover, PopoverContent } from "../../components/ui/popover";
import { useCommandPalette } from "../contexts/command-palette-context";
import * as styles from "./command-palette.module.css";
import { CommandPaletteFilters } from "./filters/command-palette-filters";
import { CommandPaletteFooter } from "./footer/command-palette-footer";
import { CommandPaletteSearchInput } from "./search-input/command-palette-search-input";
import { CommandPaletteSearchView } from "./search-view/command-palette-search-view";

export interface CommandPaletteProps {
  defaultOpen?: boolean;
  children?: React.ReactNode;
}

export const CommandPalette = memo(function CommandPalette({
  children,
}: CommandPaletteProps) {
  const { state, actions } = useCommandPalette();

  return (
    <>
      {state.isOpen && (
        <div className={styles.overlay} onClick={actions.closePalette} />
      )}
      <Popover
        onOpenChange={(open) =>
          open ? actions.openPalette() : actions.closePalette()
        }
        open={state.isOpen}
      >
        {children}
        <PopoverContent
          align="center"
          className={`w-[650px] max-h-[80vh] !p-0 ${styles.popoverContent}`}
          side="bottom"
          sideOffset={-28}
        >
          <div className={styles.modalContent}>
            <CommandPaletteSearchInput
              onChange={actions.setSearchValue}
              value={state.searchValue}
            />
            <CommandPaletteFilters />
            <CommandPaletteSearchView searchValue={state.searchValue} />
            <CommandPaletteFooter />
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
});
